<template>
  <div>
    <bar-top></bar-top>
    <alert-handler ref="alert"/>
    <div class="row ">
        <div class="col-md-2 offset-md-1">
          <h2>{{detailTitle}}</h2>
        </div>
        <div class="col-md-8 offset-md-3">
          <b-button variant="default" size="sm" v-if="isReadOnly && privUser" @click="$router.push({ name: detailRouterUrl, params: {id: rec.id}, query: {mode: 'edit'} })">
            <i class="fa fa-pencil"></i> Edit
          </b-button>
          <b-button variant="default" size="sm" v-if="isEdit" @click="$router.push({ name: detailRouterUrl, params: {id: rec.id}})">
            <i class="fa fa-undo"></i> Undo Edit
          </b-button>
          <b-button variant="default" size="sm" v-if="isEdit && !(tableCfg.disableDelete && tableCfg.disableDelete(rec)) && privUser" v-b-modal.modalDeleteOk>
            <!-- @click="deleteRecord()" -->
            <i class="fa fa-trash"></i> Delete
          </b-button>
          <b-button variant="default" size="sm" :disabled="isSaveDisabled" v-if="!isReadOnly" @click="submitRecord()">
            <i class="fa fa-save"></i> Save
          </b-button>
          <b-button variant="default" size="sm" @click="backToOverview()">
            <i class="fa fa-arrow-left"></i> Overview
          </b-button>
          <slot name="ExtraOptions" :rec="rec">
          </slot>
        </div>
    </div>
    <div>
      <slot name="FormLayout" :rec="rec">
        Here is the form
      </slot>
    </div>
    <!-- Modal Component -->
    <b-modal id="modalDeleteOk" :title="'Delete '+ this.deleteTitle" ok-title="Yes" close-title="No" @ok="deleteRecord" >
      Are you sure you want to delete this {{deleteTitle}}?
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import PrivilegeMixin from './PrivilegeMixin'
import barTop from './BarTop.vue'
import alertHandler from './AlertHandler.vue'
import api from '../api'
import Validation from '../validation'

export default {
  components: { barTop, alertHandler },
  mixins: [PrivilegeMixin],
  props: {
    tableCfg: {type: Object, required: true}
  },
  data () {
    return {
      rec: {},
      queryInprogress: false
    }
  },
  computed: {
    isReadOnly () { return !this.isEdit && !this.isNew },
    isEdit () { return this.$route.query.mode === 'edit' },
    isNew () { return this.$route.params.id === 'new' },
    isSaveDisabled () { return this.queryInprogress },
    detailTitle () { return this.getTblCfg('detailTitle') },
    detailRouterUrl () { return this.getTblCfg('detailRouterUrl') },
    overviewRouterUrl () { return this.getTblCfg('overviewRouterUrl') },
    deleteTitle () { return this.getTblCfg('deleteTitle') }
  },
  mounted () {
    // console.log('Mounted DetailLayout')
    this.getRecord()
  },
  methods: {
    getTblCfg (key) {
      if (typeof this.tableCfg[key] === 'function') return this.tableCfg[key](this)
      else return this.tableCfg[key]
    },
    backToOverview () { this.$router.push({name: this.overviewRouterUrl}) },
    getRecord () {
      if (this.isNew) {
        Validation.setOriginalRec(this.$parent.validator, {})
        if (this.tableCfg.updateNewRecord) this.tableCfg.updateNewRecord(this, this.rec)
        this.$parent.setDataValid()
      } else {
        let id = this.$route.params.id
        // console.log(this.$route.params, this.$route.query)
        api.get(this.tableCfg.detailApiUrl + id, null,
        data => {
          this.rec = data

          if (!this.readOnly) {
            Vue.nextTick(() => this.validateForm(null))
          }
          Validation.setOriginalRec(this.$parent.validator, data)
          this.$parent.setDataValid()
        },
        error => {
          console.log(error)
        }, this)
      }
    },
    validateForm (okFnc, failFnc) { Validation.validateAll(this.$parent.validator, this.rec, okFnc, failFnc) },
    submitRecord () { this.validateForm(this.commitRecord) },
    commitRecord (rec) {
      this.queryInprogress = true
      if (this.isNew) {
        api.post(this.tableCfg.detailApiUrl, rec,
        data => {
          this.queryInprogress = false
          this.$router.push({name: this.detailRouterUrl, params: {id: data.id}})
        },
        'saving new ' + this.detailTitle, this.$refs.alert)
      } else {
        api.putUpdate(this.tableCfg.detailApiUrl + rec.id, rec,
        data => {
          this.queryInprogress = false
          this.$router.push({name: this.detailRouterUrl, params: {id: rec.id}})
        },
        'saving update', this.$refs.alert)
      }
    },
    deleteRecord () {
      api.delete(this.tableCfg.detailApiUrl + this.rec.id,
      data => { this.backToOverview() },
      'deleting ' + this.detailTitle, this.$refs.alert)
    }
  }
}
</script>



// WEBPACK FOOTER //
// DetailLayout.vue?8dcc201a